import Vue from 'vue/dist/vue.esm'
export const EventBus = new Vue();
